import type {} from "services-comun/modules/types.d.ts";

import {LandingApps} from '../controllers/landing-apps';
import init from "../utils/init";

init.addModulo(LandingApps)
